var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import Text from "../Text/Text";
import colors from "../../tokens/colors.json";
import styled from "styled-components";
import { IconMinus, IconPlus } from "@tabler/icons-react";
var getSize = function (size) {
    switch (size) {
        case "large":
            return {
                size: "3rem",
                iconSize: "1.5rem",
                width: "5rem",
                fontSize: "1rem",
            };
        case "medium":
            return {
                size: "2.5rem",
                iconSize: "1.25rem",
                width: "5rem",
                fontSize: "1rem",
            };
        case "small":
            return {
                size: "2rem",
                iconSize: "1rem",
                width: "4rem",
                fontSize: "0.875rem",
            };
    }
    return {
        size: "2.5rem",
        iconSize: "1.25rem",
        width: "5rem",
        fontSize: "1rem",
    };
};
var NumberInputContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: fit-content;\n  gap: 0.5rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: fit-content;\n  gap: 0.5rem;\n"])));
var NumberInputContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  border: 1.5px solid ", ";\n  border-radius: 4px;\n  height: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  border: 1.5px solid ", ";\n  border-radius: 4px;\n  height: ", ";\n"])), colors.secondary["300"], function (props) { return getSize(props.size).size; });
var NumberInputCalculate = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  color: ", ";\n  border: none;\n  border-radius: ", ";\n  cursor: pointer;\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  color: ", ";\n  border: none;\n  border-radius: ", ";\n  cursor: pointer;\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) { return getSize(props.size).size; }, function (props) { return getSize(props.size).size; }, colors.secondary["100"], colors.secondary["700"], function (props) {
    return props.position === "left" ? "4px 0 0 4px" : "0 4px 4px 0";
}, function (props) {
    return getSize(props.size).iconSize;
}, function (props) {
    return getSize(props.size).iconSize;
}, colors.secondary["200"]);
var NumberInputInput = styled.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  font-family: \"Source Sans 3\", sans-serif;\n  font-size: ", ";\n  width: ", ";\n  height: ", ";\n  border: none;\n  padding: 0 1rem;\n  box-sizing: border-box;\n  margin: 0;\n  &::-webkit-inner-spin-button,\n  &::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  &:focus {\n    outline: none;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  font-family: \"Source Sans 3\", sans-serif;\n  font-size: ", ";\n  width: ", ";\n  height: ", ";\n  border: none;\n  padding: 0 1rem;\n  box-sizing: border-box;\n  margin: 0;\n  &::-webkit-inner-spin-button,\n  &::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  &:focus {\n    outline: none;\n  }\n"])), function (props) { return getSize(props.size).fontSize; }, function (props) { return getSize(props.size).width; }, function (props) { return getSize(props.size).size; });
var NumberInput = function (_a) {
    var id = _a.id, placeholder = _a.placeholder, value = _a.value, className = _a.className, style = _a.style, label = _a.label, min = _a.min, max = _a.max, step = _a.step, size = _a.size, disabled = _a.disabled, onChange = _a.onChange, onIncrement = _a.onIncrement, onDecrement = _a.onDecrement;
    var _b = React.useState(label), numberInputLabel = _b[0], setNumberInputLabel = _b[1];
    var _c = React.useState(value !== null && value !== void 0 ? value : 0), finalValue = _c[0], setFinalValue = _c[1];
    useEffect(function () {
        setNumberInputLabel(label ? (typeof label === "string" ? (_jsx(Text, __assign({ variant: "paragraph" }, { children: label }))) : (label)) : undefined);
    }, [label]);
    var _onMinusClick = function (e) {
        if (!finalValue) {
            setFinalValue(-1);
        }
        else {
            setFinalValue(finalValue - 1);
        }
        onDecrement && onDecrement(e, finalValue);
    };
    var _onPlusClick = function (e) {
        if (!finalValue) {
            setFinalValue(1);
        }
        else {
            setFinalValue(finalValue + 1);
        }
        onIncrement && onIncrement(e, finalValue);
        onChange && onChange(e, finalValue);
    };
    var _onChange = function (e) {
        if (e.target.value === "") {
            setFinalValue(0);
        }
        else {
            setFinalValue(parseInt(e.target.value));
        }
        onChange && onChange(e, parseInt(e.target.value));
    };
    return (_jsxs(NumberInputContainer, __assign({ id: id, className: className, style: style }, { children: [numberInputLabel, _jsxs(NumberInputContent, __assign({ size: size }, { children: [_jsx(NumberInputCalculate, __assign({ position: "left", size: size, onClick: _onMinusClick }, { children: _jsx(IconMinus, {}) })), _jsx(NumberInputInput, { placeholder: placeholder, type: "number", size: size, max: max, min: min, value: finalValue, step: step, onChange: _onChange }), _jsx(NumberInputCalculate, __assign({ position: "right", size: size, onClick: _onPlusClick }, { children: _jsx(IconPlus, {}) }))] }))] })));
};
export default NumberInput;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
